import type { FunctionComponent } from "react";
import styled from "styled-components";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { ButtonPlaceholderLoader, PixelPlaceholderLoader } from "@similarweb/ui-components";
import {
    ContentWrapper,
    CtaLoaderWrapper,
    TitleWrapper,
} from "app/pages/website-analysis/components/qualification-sidebar/components/StyledComponents";

const TitleLoaderWrapper = styled(FlexColumn)`
    justify-content: space-between;
    height: 48px;
`;

const TitleLoader: FunctionComponent = () => (
    <TitleWrapper>
        <TitleLoaderWrapper>
            <PixelPlaceholderLoader
                width={"330px"}
                height={"24px"}
            />
            <PixelPlaceholderLoader
                width={"220px"}
                height={"16px"}
            />
        </TitleLoaderWrapper>
    </TitleWrapper>
);

const ContentLoader: FunctionComponent<{ height: string }> = ({ height }) => (
    <ContentWrapper height={height}>
        <PixelPlaceholderLoader
            width={"100%"}
            height={"100%"}
        />
    </ContentWrapper>
);

const CtaLoader: FunctionComponent = () => (
    <CtaLoaderWrapper>
        <ButtonPlaceholderLoader id="lineGray" />
    </CtaLoaderWrapper>
);

export const ComponentsLoader: FunctionComponent = () => (
    <>
        <TitleLoader />
        <ContentLoader height={"230px"} />
        <CtaLoader />
    </>
);
